import { useQuery } from '@tanstack/react-query';
import { useConfig } from '../hooks';
import { getHelpCard } from '../services/backendService';
import type { HelpCard } from '../types/helpCard.types';
import { useLanguage } from './i18n';
import { ApiError } from './api';

interface UseHelpCardsResult {
  cards: HelpCard[];
  isLoading: boolean;
  isError: boolean;
  error: ApiError | null;
}

export const useHelpCards = (): UseHelpCardsResult => {
  const { data: config, isLoading: isConfigLoading } = useConfig();
  const { language } = useLanguage();
  const helpCardIds = config?.helpCards ?? [];
  const shouldFetch = helpCardIds.length > 0;

  const query = useQuery<HelpCard[], ApiError>({
    queryKey: ['helpCards', config?.id, helpCardIds, language],
    queryFn: async () => {
      return Promise.all(helpCardIds.map((helpCardId) => getHelpCard({ helpCardId, language })));
    },
    enabled: shouldFetch,
  });

  const helpCards = shouldFetch ? (query.data ?? []) : [];
  const isLoading = isConfigLoading || (shouldFetch ? query.isLoading : false);

  return {
    cards: helpCards,
    isLoading,
    isError: query.isError,
    error: query.error ?? null,
  };
};
